import axiosInstanceAI from "@/api/axiosInstanceAI";

export const fetchAITrainerChat = async({userId, threadId})=>{
    try {
        const response = await axiosInstanceAI.get("/trainthetrainer/chat/", {
          params: { user_id: userId, ...(threadId && { thread_id: threadId }) },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching AITrainer chat:", error);
        throw error;
    }
}

export const fetchAITrainerThreads = async ({ userId }) => {
  const response = await axiosInstanceAI.get("/trainthetrainer/chat/threads", {
    params: { user_id: userId },
  });
  return response.data;
};

export const createAITrainerThread = async ({
  userId,
  campaignId,
  campaignName,
}) => {
  const response = await axiosInstanceAI.post("/trainthetrainer/chat/threads", {
    user_id: userId,
    ...(campaignId && {
      entity_type: "campaign",
      entity_id: String(campaignId),
      entity_name: campaignName,
    }),
  });
  return response.data;
};

export const renameAITrainerThread = async ({ userId, threadId, title }) => {
  const response = await axiosInstanceAI.patch(
    `/trainthetrainer/chat/threads/${encodeURIComponent(threadId)}`,
    { user_id: userId, title },
  );
  return response.data;
};

export const pinAITrainerThread = async ({
  userId,
  threadId,
  campaignId,
  campaignName,
}) => {
  const response = await axiosInstanceAI.patch(
    `/trainthetrainer/chat/threads/${encodeURIComponent(threadId)}`,
    {
      user_id: userId,
      entity_type: "campaign",
      entity_id: String(campaignId),
      entity_name: campaignName,
    },
  );
  return response.data;
};

export const deleteAITrainerThread = async ({ userId, threadId }) => {
  const response = await axiosInstanceAI.delete(
    `/trainthetrainer/chat/threads/${encodeURIComponent(threadId)}`,
    { params: { user_id: userId } },
  );
  return response.data;
};

export const fetchAITrainerMemories = async({userId, campaignId})=>{
    try {
        const params = new URLSearchParams({ user_id: userId });
        if (campaignId) params.append("campaign_id", campaignId);
        const response = await axiosInstanceAI.get(
          "/trainthetrainer/memories/?" + params.toString(),
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching AITrainer memories:", error);
        throw error;
    }
}

export const deleteAITrainerMemory = async ({ userId, memoryId }) => {
  const response = await axiosInstanceAI.delete(
    `/trainthetrainer/memories/${encodeURIComponent(memoryId)}`,
    { params: { user_id: userId } },
  );
  return response.data;
};

export const updateAITrainerMemory = async ({
  userId,
  memoryId,
  text,
  channels,
}) => {
  const response = await axiosInstanceAI.patch(
    `/trainthetrainer/memories/${encodeURIComponent(memoryId)}`,
    { text, ...(channels ? { channels } : {}) },
    { params: { user_id: userId } },
  );
  return response.data;
};

// get chat answer
export const getChatAnswerAiTrainer = async ({
  user_id = "",
  thread_id = "",
  prompt = "",
  display = null,
}) => {
    try {
      const formData = new URLSearchParams();
      formData.append("user_id", user_id);
      formData.append("prompt", prompt);
      if (thread_id) formData.append("thread_id", thread_id);
      if (display) formData.append("display", display);
  
      const baseURL =
        axiosInstanceAI.defaults.baseURL ||
        process.env.REACT_APP_AI_BASE_URL;
  
      const token = localStorage.getItem("token");
  
      const response = await fetch(`${baseURL}/trainthetrainer/chat/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: formData.toString(),
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP error! status: ${response.status}`);
      }
  
      // Streaming response
      return response.body;
    } catch (error) {
      console.error("Error fetching chat answer:", error);
      throw error;
    }
  };
  
